<template>
    <div class="main">
        <img src="@/assets/logo.png" />
        <svg id="rotatingText" viewBox="0 0 200 200" width="55vw" height="55vw">
            <defs>
                <path id="circle" d="M 100, 100
                m -75, 0
                a 75, 75 0 1, 0 150, 0
                a 75, 75 0 1, 0 -150, 0
                ">
                </path>
            </defs>
            <text>
                <textPath xlink:href="#circle" class="text">
                    YUYU-VOICE 鱼鱼语音 YUYU-VOICE 鱼鱼语音
                </textPath>
            </text>
        </svg>
    </div>

</template>

<style lang="css" scoped>
.text {
    letter-spacing: 0.265rem;
    font-weight: 400;
    /* font-family: 'Kanit'; */
    font-size: 1rem;
    fill: #fff;
    text-shadow: 2px 0px #000;
}

.main {
    display: flex;
    align-items: center;
    justify-items: center;
}

.main img {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    object-fit: cover;
    border-radius: 50%;
    width: 16vh;
    height: 16vh;
    filter: drop-shadow(0px 0px 4px #00000053);

    /* animation-name: rotate-circle;
    animation-direction: reverse;
    animation-duration: 5s;
    animation-timing-function: linear;
    animation-iteration-count: infinite; */
}

#rotatingText {
    animation-name: rotate-circle;
    animation-duration: 10s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    width: 28vh;
    height: 28vh;
    /* max-height: 50vh; */
}

@keyframes rotate-circle {
    to {
        transform: rotate(1turn);
    }
}
</style>